export function GetJSData(mapObject) {
  return mapObject.data.toJS();
}

export function GetJSDataWithKey(key, mapObject) {
  return mapObject?.[key]?.toJS() ?? [];
}
